
import accountSwitcher from '@/api/accountSwitcher';
import { mapState } from 'vuex';

export default {
  name: 'NavigationAccountSwitcher',

  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('user', ['currentAccount']),
  },

  data: () => {
    return {
      logins: [],
    };
  },

  created() {
    this.grabLogins();
  },

  methods: {
    grabLogins() {
      accountSwitcher.getLogins().then((rsp) => {
        this.logins = rsp.data.data;
      });
    },

    switchTo(login) {
      accountSwitcher.switchTo({ account_uuid: login.account.uuid }).then((rsp) => {
        location.reload();
      });
    },

    getRole(login) {
      if (login.account.type === 'client') {
        return 'Client';
      }

      let formattedRole = this.$helpers.sentencify(login.account.role ?? '');
      if (login.user_type === 'enterprise') {
        formattedRole = `Enterprise ${formattedRole}`.trim();
      }

      return formattedRole;
    },
  },
};
